import { CMSResource } from "app/resources/cmsresource";

export class FooterLinksTypeResource extends CMSResource {

    rid: number;

    keyName: string;

    image: boolean;

    url: boolean;

    text: boolean;

    nameRo: string;

    nameFr: string;

    nameEn: string;
    
    nameDe: string;

}